<template>

  <v-app>
    <router-view />
    <v-snackbar-queue v-model="NotificationService.messages.value" />
  </v-app>

  <dialog-wrapper />  

  <v-overlay
    v-model="GlobalDataService.loading.value"
    class="align-center justify-center"
    persistent
  >
    <v-progress-circular
      color="primary"
      indeterminate
      size="64"
    />
  </v-overlay>

</template>

<script setup lang="ts">

import { RouterView } from 'vue-router'
// @ts-ignore: don't complain about vue3-promise-dialog's missing typings
import { DialogWrapper } from 'vue3-promise-dialog'
import NotificationService from './services/NotificationService'
import GlobalDataService from './services/GlobalDataService'

</script>
